var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('strong',[_vm._v(_vm._s(_vm.chave))])]),_c('div',{staticClass:"col-6"},[_vm._v(" "+_vm._s(_vm.valor)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }